
/**
 * Checks if 'value' respects the variable format {{str}}.
 *
 * @param {*} value The value to check if is variable.
 * @returns {Boolean} True if variable, else false.
 * @example
 *
 * isVariable("{{value}}");
 * // -> true
 *
 * isVariable("{{123value}}");
 * // -> true
 *
 * isVariable("{value}");
 * // -> false
 *
 * isVariable("{{value}} extra");
 * // -> false
 */

export const isVariable = (value) => {
  const regex = /^\{\{.*\}\}$/;
  return regex.test(value);
};
